import React from "react";

export const Rotate = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 16 16"
    >
      <path d="M10.78 14.266c-.736.267-1.473.4-2.21.4-2.746 0-5.358-1.736-6.296-4.473-.134-.334.067-.735.402-.869.335-.133.737.067.87.401C4.552 12.53 7.567 14 10.38 12.997c2.813-1.002 4.287-4.006 3.282-6.811-.47-1.336-1.474-2.404-2.746-3.072a5.412 5.412 0 00-4.086-.2c-.737.267-1.474.668-2.01 1.269L2.877 5.986H5.22c.402 0 .67.267.67.667 0 .401-.268.668-.67.668H1.001l-.067-.067c-.067 0-.067-.066-.134-.066 0 0 0-.067-.067-.067 0-.067-.066-.067-.066-.134v-4.34c0-.401.267-.668.67-.668.401 0 .67.267.67.668v2.47l2.009-1.87c.67-.667 1.54-1.201 2.478-1.535 1.674-.601 3.483-.468 5.09.267 1.608.801 2.814 2.137 3.416 3.806 1.14 3.473-.736 7.279-4.22 8.481z" />
    </svg>
  );
};
